<template>
    <div class="map">
        <div class="adrees-serach display_flex" id="r-result">
            <input
                type="text"
                placeholder="搜索商铺附近的位置"
                id="suggestId"
                class="serach-input"
                v-model="serarchAdress"
                @focus="focus"
                ref="inputs"
            />
            <div class="serach-btn" @click="serarch">搜索</div>
            <div class="result-list" v-show="result">
                <li
                    class="result-item"
                    v-for="(item,index) in surroundingPois"
                    v-if="index < 3"
                    @click="chooseAddress(item.province +
                item.city +
                item.district +
                item.street +
                item.streetNumber + item.business)"
                >
                    {{item.province +
                    item.city +
                    item.district +
                    item.street +
                    item.streetNumber + item.business}}
                </li>
            </div>
        </div>

        <div id="map"></div>
        <div class="marker"></div>
        <div class="map-bot" v-show="show">
            <div class="tip display_flex align-center justify-between">
                <span>商铺地址</span>
                <span>请拖动地图获取地址</span>
            </div>
            <div class="edit-address">
                <div class="edit-info">
                    <textarea class="adit" v-model="address" ref="focusTextarea" @focus="getFouce"></textarea>
                    <p @click="getFouce">点击地址编辑添加更多信息</p>
                </div>
            </div>
            <div class="sure" @click="sure" v-show="flag">确定</div>
        </div>
    </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import qs from "qs";
export default {
  data() {
    return {
      show: true,
      address: "",
      surroundingPois: [],
      serarchAdress: "",
      point: "",
      flag: true,
      result: false,
      mapObj: ""
    };
  },
  mounted() {
    this.map();
    // iPhone X、iPhone XS
    var isIPhoneX =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 375 &&
      window.screen.height === 812;
    // iPhone XS Max
    var isIPhoneXSMax =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    // iPhone XR
    var isIPhoneXR =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 2 &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      // if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        $(".adrees-serach").css({ marginTop: ".8rem" });
        $(".sure").css({ borderBottom: ".1rem solid #4A90E2" });
      // }
    }

    var u = navigator.userAgent,
      app = navigator.appVersion;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.addEventListener("focusin", () => {
        // 键盘弹出事件处理
        this.flag = false;
      });
      window.addEventListener("focusout", () => {
        // 键盘收起事件处理
        this.flag = true;
        this.show = true;
        $("#suggestId").blur();
      });
    } else if (isAndroid) {
      $(".adrees-serach").css({ marginTop: ".8rem" });
      const innerHeight = window.innerHeight;
      window.addEventListener("resize", () => {
        const newInnerHeight = window.innerHeight;
        if (innerHeight > newInnerHeight) {
          this.flag = false;
        } else {
          // 键盘收起事件处理
          this.flag = true;
          this.show = true;
          $("#suggestId").blur();
        }
      });
    }
  },
  watch: {
    serarchAdress() {
      if (this.serarchAdress == "") {
        this.surroundingPois = [];
      }
    }
  },
  methods: {
    map() {
      var that = this;
      var map = new BMap.Map("map");
      this.mapObj = map;
      var point = new BMap.Point(116.331398, 39.897445);
      var ac;
      map.centerAndZoom(point, 13);
      map.enableAutoResize();
      var geolocation = new BMap.Geolocation();
      var offsetY = 200;
      offsetY = 0;
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            ac = new BMap.Autocomplete({
              input: "suggestId",
              location: r.address.city,
              onSearchComplete: function(data) {
                ac.hide();
                that.surroundingPois = [];
                data.Ir.forEach(function(el){
                  if (el.city) {
                    that.surroundingPois.push(el)
                  }
                })
              }
            });
            map.panTo(r.point);
            that.point = r.point;
            that.address =
              r.address.province +
              r.address.city +
              r.address.district +
              r.address.street +
              r.address.street_number;
            //地图拖动获取中心位置经纬度
            var centerPixel = map.pointToOverlayPixel(map.getCenter());
            map.setCenter(
              map.overlayPixelToPoint({
                x: centerPixel.x,
                y: centerPixel.y + offsetY
              })
            );
            map.addEventListener("dragend", function(e) {
              that.blur();
              that.serarchAdress = "";
              var pixel = map.pointToOverlayPixel(map.getCenter());
              var Point = map.overlayPixelToPoint({
                x: pixel.x,
                y: pixel.y - offsetY
              });
              var myGeo = new BMap.Geocoder();
              myGeo.getLocation(Point, function(rs) {
                ac.setLocation(rs.addressComponents.city)
                that.point = rs.point;
                that.address = rs.address;
              });
            });
          } else {
            alert("failed" + this.getStatus());
          }
        },
        { enableHighAccuracy: true }
      );
      map.addEventListener("touchmove", function(e) {
        map.enableDragging();
      });
      map.addEventListener("touchend", function(e) {
        map.disableDragging();
      });
      map.disableDragging();
      map.addEventListener("click", function() {
        that.blur();
        $("#suggestId").blur();
      });
    },
    serarch() {
      var that = this;
      that.result = false;
      var map = that.mapObj;
      var myGeo = new BMap.Geocoder();
      if (that.surroundingPois[0]) {
        that.serarchAdress = that.surroundingPois[0].province +
        that.surroundingPois[0].city +
        that.surroundingPois[0].district +
        that.surroundingPois[0].street +
        that.surroundingPois[0].streetNumber + that.surroundingPois[0].business
        that.address = that.serarchAdress;
      }
      if (!that.serarchAdress) {
        Toast("请输入搜索内容");
        return;
      }
      myGeo.getPoint(this.serarchAdress, function(point) {
        if (point) {
          that.point = point;
          map.centerAndZoom(point, 13);
        } else {
          Toast("您选择地址没有解析到结果!");
        }
      });
    },
    chooseAddress(address) {
      this.serarchAdress = address;
      this.address = address;
      this.serarch();
    },
    sure() {
      var message = {
        address: this.address,
        point: this.point,
        page: 1,
        tip: "基本信息",
        title: "发布商铺"
      };
      window.parent.postMessage(message, "*");
    },
    focus() {
      this.show = true; //u false
      this.result = true;
      this.flag = true; //c
    },
    blur() {
      this.$refs.focusTextarea.blur();
      this.$refs.inputs.blur();
      this.flag = true;
      this.result = false;
    },
    getFouce() {
      this.$refs.focusTextarea.focus();
      this.flag = true;//u false
      this.show = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.map {
  height: 100vh;
  background: #fff;
  position: relative;
  .marker {
    position: absolute;
    width: 0.64rem;
    height: 0.64rem;
    background: url("../../../static/images/publish/dw.png") no-repeat center;
    background-size: 100% 100%;
    top: 50%;
    left: 50%;
    margin: -0.64rem 0 0 -0.32rem;
  }
  .display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
  }
  .align-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .justify-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }
  .adrees-serach {
    padding: 0.1rem 0.4rem;
    height: 1rem;
    position: fixed;
    top: 1.1rem;
    left: 0;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    z-index: 99;
    .serach-input {
      flex: 1;
      background: #f7f7f7;
      font-size: 0.28rem;
      padding-left: 0.3rem;
      margin-right: 0.1rem;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .serach-btn {
      height: 100%;
      width: 1.46rem;
      text-align: center;
      line-height: 0.9rem;
      color: #fff;
      font-size: 0.28rem;
      background: #4a90e2;
    }
  }

  .result-list {
    padding: 0 0.4rem;
    position: absolute;
    width: 100%;
    left: 0;
    background: rgba(255, 255, 255, 0.9);
    top: 1rem;
    z-index: 9999;
    box-sizing: border-box;
    .result-item {
      padding-left: 0.3rem;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.28rem;
      color: #333;
      border-bottom: 1px solid #eee;
      list-style: none;
      overflow-x: auto;
      //   text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  #map {
    height: 100%;
    width: 100%;
  }
  .tip {
    padding: 0 0.4rem;
    height: 0.97rem;
    font-size: 0.26rem;
    color: #666;
    box-sizing: border-box;
  }
  .edit-address {
    padding: 0 0.4rem;
    box-sizing: border-box;
    .edit-info {
      padding: 0.3rem;
      box-sizing: border-box;
      background: #fef7ea;
      margin-bottom: 0.2rem;
      .adit {
        width: 100%;
        min-height: 1rem;
        background: #fef7ea;
        border: none;
        outline: none;
        font-size: 0.28rem;
        color: #333;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      p {
        font-size: 0.22rem;
        color: #999;
      }
    }
  }
  .sure {
    width: 100%;
    height: 1.2rem;
    background: #4a90e2;
    z-index: 999;
    color: #fff;
    text-align: center;
    line-height: 1.2rem;
    font-size: 0.36rem;
  }
  .map-bot {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 99;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publish/map.vue